import { ConfirmPopUp } from './ConfirmPopUp';

export class ThankYouPopup extends ConfirmPopUp {
    protected drawLayout(params: any): void {
        super.drawLayout(params);
        this.image.scale.set(0.7, 0.7);
    }
}